<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="4">
                <v-card>
                    <v-card-title class="primary title white--text mb-3">Admin Login</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="submit">
                            <v-text-field prepend-inner-icon="mdi-account" v-model="email" label="Email"></v-text-field>
                            <v-text-field prepend-inner-icon="mdi-lock" v-model="password" label="Password" type="password"></v-text-field>
                            <div class="mt-3">
                                <v-btn color="primary" type="submit">
                                    <v-icon left>mdi-login</v-icon>
                                    Login
                                </v-btn>
                                <span class="px-3 error--text">{{ error }}</span>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
                <div class="text-center my-6 title">
                    <router-link to="/">Portal Home</router-link>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'Login',
        data: () => ({
            email: '',
            password: '',
            error: ''
        }),
        methods: {
            submit() {
                this.error = '';
                this.$api
                    .post('/admin/login', { email: this.email, password: this.password })
                    .then(() => {
                        window.location.href = '/admin';
                    })
                    .catch((error) => {
                        this.error = error.response.data;
                    });
            }
        }
    };
</script>
